import HttpClientManager from '@/business/core/clients/http/helpers/manager.helper';
import type { AdminPushNotificationPayload, PushSubscriptionPayload } from './pushNotification.model';

class PushNotificationRepository {
	static #instance: PushNotificationRepository;
	private readonly httpClient;
	private readonly PUSH_NOTIFICATIONS = 'PushNotifications';
	private readonly ADMIN_PUSH_NOTIFICATIONS = 'Admin/PushNotifications';

	private constructor() {
		this.httpClient = HttpClientManager.getInstance();
	}

	public static getInstance(): PushNotificationRepository {
		if (!PushNotificationRepository.#instance) {
			PushNotificationRepository.#instance = new PushNotificationRepository();
		}

		return PushNotificationRepository.#instance;
	}

	getPublicKey() {
		return this.httpClient(`${this.PUSH_NOTIFICATIONS}/PublicKey`, {
			method: 'get',
		});
	}

	subscribe(data: PushSubscriptionPayload) {
		return this.httpClient(`${this.PUSH_NOTIFICATIONS}/Subscribe`, {
			method: 'post',
			data,
		});
	}

	unsubscribe(endpoint: string) {
		return this.httpClient(`${this.PUSH_NOTIFICATIONS}/Subscribe`, {
			method: 'delete',
			data: { endpoint },
		});
	}

	sendFromAdmin(data: AdminPushNotificationPayload) {
		return this.httpClient(`${this.ADMIN_PUSH_NOTIFICATIONS}/Send`, {
			method: 'post',
			data,
			isShowNotify: true,
		});
	}
}

export default PushNotificationRepository;
